import React from 'react';

export function useNonReactiveCallback<T extends ((...args: any[]) => void) | undefined>(fn: T): T {
  const ref = React.useRef(fn);
  React.useInsertionEffect(() => {
    ref.current = fn;
  }, [fn]);
  return React.useCallback(
    (...args: any) => {
      const latestFn = ref.current;
      return latestFn?.(...args);
    },
    [ref]
  ) as unknown as T;
}
